import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/testimonial-unknown-headshot.svg'


const _withScopeId = n => (_pushScopeId("data-v-6dc34772"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "testimonial-container" }
const _hoisted_2 = { class: "testimonial-source-logo" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "testimonial-content" }
const _hoisted_5 = { class: "testimonial-author-section" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "testimonial-headshot" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_7 = { class: "testimonial-author-info" }
const _hoisted_8 = { class: "testimonial-text-bold" }
const _hoisted_9 = { class: "testimonial-text" }
const _hoisted_10 = { class: "testimonial-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, {
    width: '370px',
    height: '508px'
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("section", _hoisted_2, [
          _createElementVNode("img", {
            src: _ctx.testimonial.logoSrc
          }, null, 8, _hoisted_3)
        ]),
        _createElementVNode("section", _hoisted_4, _toDisplayString(_ctx.testimonial.content), 1),
        _createElementVNode("section", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("section", _hoisted_8, _toDisplayString(_ctx.testimonial.name), 1),
            _createElementVNode("section", _hoisted_9, _toDisplayString(_ctx.testimonial.position), 1),
            _createElementVNode("section", _hoisted_10, _toDisplayString(_ctx.testimonial.twitterHandle), 1)
          ])
        ])
      ])
    ]),
    _: 1
  }))
}